import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';
import {BehaviorSubject, catchError, firstValueFrom, map, Observable, of} from 'rxjs';
import {CustomNoRowsOverlay} from '../../../mm-project-config/configs/custom-no-rows-overlay.component';
import {ColDef, ColumnApi, GridApi} from 'ag-grid-community';
import {GridSelectionService, GridTranslationService, MydocmaGridOptions,} from '@mydocma/component-library/src/lib/grid';
import {customComparator} from '../../../mm-project-config/common/config-util';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';
import {CurrentFaultsSyncStateService} from '../../current-faults-sync-state.service';
import {MmProjectService} from '../../../mm-project/mm-project.service';
import {PermissionService} from '@docma-mm-core/permission/permission.service';
import {FaultSyncState} from '@docma-mm-core/fault/fault-sync-state';
import {GridItemSelectionService} from '../../../mm-project-config/configs/services/grid-item-selection.service';
import {MydocmaDatePipe} from '@mydocma/common';
import {SyncStatusEnum} from '@docma-mm-core/model/sync-state/sync-status.enum';
import {SyncStatusCellRendererComponent} from './sync-status-cell-renderer/sync-status-cell-renderer.component';
import {FaultService} from '@docma-mm-core/fault/fault.service';
import {Fault} from '@docma-mm-core/fault/fault';
import {FaultSyncService, SyncStateChange} from '@docma-mm-core/fault/sync/fault-sync.service';
import {Ticket} from '@docma-mm-core/ticket/ticket.interface';
import {HttpClient} from '@angular/common/http';
import {SUPPORT_CONFIG, SupportConfig} from '@docma-mm-core/ticket/support.config';
import {CommonGroupValue} from '@docma-mm-core/ticket/common-group.interface';
import {QuestionGroupValue} from '@docma-mm-core/ticket/question-group.interface';
import {DeviceService} from '@mydocma/core/src/lib/device';
import {TypeEnum} from '@docma-mm-core/ticket/enums/type.enum';
import {PriorityEnum} from '@docma-mm-core/ticket/enums/priority.enum';
import {FreshdeskCustomfieldsEnum} from '@docma-mm-core/ticket/enums/freshdesk-customfields.enum';
import {IdedMydocmaFile} from '@mydocma/common/src/lib/file';
import {AuthService, JwtAuthService} from '@mydocma/auth';
import {FaultPatchService} from '@docma-mm-core/fault/patch/fault-patch-service';
import {FaultPersistenceService} from '@docma-mm-core/fault/fault-persistence.service';
import {SyncState} from '@docma-mm-core/model/sync-state/sync-state';
import {SyncStatusFilterComponent} from './sync-status-filter/sync-status-filter.component';
import {SyncFileService} from '@docma-mm-core/sync/sync-file.service';
import {FaultPatch} from '@docma-mm-core/fault/patch/fault-patch';
import {FaultOperationPathEnum} from '@docma-mm-core/fault/patch/fault-operation-path.enum';
import JSZip from 'jszip';
import {AppContainerService} from '@mydocma/app-container';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MmFaultsSyncStatusInfoPopupComponent} from './sync-status-popup/mm-faults-sync-status-info-popup.component';
import {filter} from 'rxjs/operators';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {MmProjectLoaderService} from '../../../mm-project/mm-project-loader.service';
import {CustomerService} from '@mydocma/customer';
import package_json from '../../../../../../../../package.json';
import {MmFaultsLoaderService} from '../../mm-faults-loader.service';
import {Logger} from '@mydocma/common/src/lib/logger';
import {ConnectivityService} from '@mydocma/core';
import {FaultData} from '@docma-mm-core/fault/fault-data';
import {MmTranslateService} from '../../../mm-translate.service';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-mm-faults-sync-dialog',
  templateUrl: './mm-faults-sync-dialog.component.html',
  styleUrls: ['./mm-faults-sync-dialog.component.scss'],
  providers: [{provide: SelectionService, useExisting: GridItemSelectionService},
    GridSelectionService,
    GridTranslationService]
})
export class MmFaultsSyncDialogComponent implements OnInit, OnDestroy {

  private frameworkComponents = {
    customNoRowsOverlay: CustomNoRowsOverlay
  };
  noRowsOverlayComponent = 'customNoRowsOverlay';

  gridOptionsSubject = new BehaviorSubject<MydocmaGridOptions>(null);
  public gridOptions$ = this.gridOptionsSubject.asObservable();

  private gridApi: GridApi = null;
  private columnApi: ColumnApi = null;
  private delaySizeColumnsToFit = false;

  loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  hasErrorsSubject = new BehaviorSubject<boolean>(false);
  hasErrors$ = this.hasErrorsSubject.asObservable();

  showMobileView = false;

  currentSyncStates: FaultSyncState[] = [];
  jwtAuthService: JwtAuthService;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,
              private dialogRef: MatDialogRef<MmFaultsSyncDialogComponent>,
              private readonly gridTranslationService: GridTranslationService,
              private  readonly gridSelectionService: GridSelectionService,
              public readonly selectionService: SelectionService<any>,
              private readonly translationService: MmTranslateService,
              private readonly faultsSyncStateService: CurrentFaultsSyncStateService,
              private readonly projectService: MmProjectService,
              private readonly permissionService: PermissionService,
              private readonly datepipe: MydocmaDatePipe,
              readonly faultService: FaultService,
              private readonly faultSyncService: FaultSyncService,
              private httpClient: HttpClient,
              @Inject(SUPPORT_CONFIG) private taskConfig: SupportConfig,
              public deviceService: DeviceService,
              private readonly authService: AuthService,
              private readonly patchService: FaultPatchService,
              private readonly persistenceService: FaultPersistenceService,
              private readonly syncFileService: SyncFileService,
              private readonly appContainerService: AppContainerService,
              private readonly matDialog: MatDialog,
              private readonly projectLoaderService: MmProjectLoaderService,
              private readonly customerService: CustomerService,
              private readonly faultsLoaderService: MmFaultsLoaderService,
              private readonly logger: Logger,
              private readonly connectivityService: ConnectivityService) {

    this.jwtAuthService = this.authService as any;
  }

 async ngOnInit() {
   const project = await firstValueFrom(this.projectService.currentProject);
   await this.faultsSyncStateService.set(project.MyDocmaUid);

   this.delaySizeColumnsToFit = true;

   if (this.showMobileView) {
     await this.setDataSource();
   } else {
     await this.buildGrid();
   }

   this.appContainerService.mobileView$.pipe(untilDestroyed(this)).subscribe(isMobile => {
     this.setDataSource();
     this.showMobileView = isMobile;
   });
 }

  private async buildGrid(): Promise<void> {
    const cols = await this.getColumnDefs();

    this.gridOptionsSubject.next({
      rowSelection: 'multiple',
      frameworkComponents: this.frameworkComponents,
      context: { componentParent: this },
      rowDragManaged: false,
      animateRows: true,
      suppressRowClickSelection: true,
      suppressCellSelection: true,
      enableFillHandle: true,
      rowDragMultiRow: false,
      rowDragEntireRow: false,
      rowHeight: 32,
      headerHeight: 40,
      suppressLoadingOverlay: true,
      columnDefs: cols,
      onGridReady: (params) => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridTranslationService.attach(this.gridOptionsSubject.value, 'COMP-LIB.mydocmaGrid.agGrid');
        this.gridSelectionService.attach(this.gridOptionsSubject.value, 'isChecked');
        this.setDataSource();
      },
      onRowDataChanged: () => {
        this.selectionService.stopSelectionMode();
      }
    } as MydocmaGridOptions);
  }

  private async getColumnDefs(): Promise<ColDef[]> {

    // const project = await firstValueFrom(this.projectService.currentProject);
    // const permissions = await firstValueFrom(this.permissionService.getProjectPermissions(project.Id));
    // const showIdColumns = permissions.AdminActions.find(x => x== ActionPermissionEnum.ShowIdColumns);

    return [
      {
        colId: 'syncState',
        field: 'SyncState',
        cellRenderer: SyncStatusCellRendererComponent,
        headerName: this.translationService.instant('MM.syncFaults.dialog.colSyncState'),
        suppressMovable: true,
        suppressAutoSize: true,
        suppressSizeToFit: true,
        resizable: true,
        maxWidth: 100,
        cellClass: 'checkbox-cell',
        valueGetter: (params) => {
          const data: FaultSyncState = params.data;
          return !data.SyncStatus;
        },
        sortable: true,
        filter: SyncStatusFilterComponent,
        filterParams: {
          showAllOption: false,
          filterValueGetter: (data: FaultSyncState) => {
            return data.SyncStatus;
          },
          selectableOptions: [
            {
              id: 100,
              value: SyncStatusEnum.NotSync,
              selected: true,
              icon: '_warning-filled',
            },
            {
              id: 200,
              value: SyncStatusEnum.Error,
              selected: true,
              icon: '_high-priority'
            }
          ]
        }
      },
      {
        colId: 'number1',
        field: 'Number1',
        width: 110,
        resizable: true,
        pinned: false,
        suppressAutoSize: true,
        suppressSizeToFit: true,
        suppressMovable: true,
        headerName: this.translationService.instant('MM.syncFaults.dialog.colNumber'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          filterOptions: ['equals', 'notEqual', 'lessThan', 'lessThanOrEqual', 'greaterThan', 'greaterThanOrEqual']
        }
      },
      {
        colId: 'number2',
        field: 'Number2',
        width: 110,
        resizable: true,
        pinned: false,
        suppressAutoSize: false,
        suppressSizeToFit: true,
        suppressMovable: true,
        headerName: this.translationService.instant('MM.syncFaults.dialog.colNumber2'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          filterOptions: ['contains', 'notContains', 'equals', 'notEqual']
        },
        comparator: customComparator,
      },
      {
        colId: 'description',
        field: 'Desc1_1',
        width: 250,
        resizable: true,
        pinned: false,
        suppressAutoSize: false,
        suppressSizeToFit: false,
        suppressMovable: true,
        headerName: this.translationService.instant('MM.syncFaults.dialog.colDescription'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          filterOptions: ['contains', 'notContains', 'equals', 'notEqual']
        },
        comparator: customComparator,
      },
      {
        colId: 'modifiedOn',
        field: 'ModifiedOn',
        type: 'Date',
        valueFormatter: (params) => this.datepipe.transform(params.value, 'dd.MM.YYYY HH:mm:ss'),
        width: 180,
        resizable: true,
        pinned: false,
        suppressAutoSize: true,
        suppressSizeToFit: true,
        suppressMovable: true,
        headerName: this.translationService.instant('MM.syncFaults.dialog.colModifiedOn'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          includeBlanksInLessThan: true,
          includeBlanksInGreaterThan: true,
          includeBlanksInEquals: true,
          filterOptions: ['equals', 'notEqual', 'lessThan', 'greaterThan', 'empty'],
          comparator: dateWithoutTimeComparator
        }
      },
      {
        colId: 'lastSyncAttemptOn',
        field: 'LastSyncAttemptOn',
        type: 'Date',
        valueFormatter: (params) => this.datepipe.transform(params.value, 'dd.MM.YYYY HH:mm:ss'),
        width: 180,
        resizable: true,
        pinned: false,
        suppressAutoSize: true,
        suppressSizeToFit: true,
        suppressMovable: true,
        headerName: this.translationService.instant('MM.syncFaults.dialog.colLastSyncAttemptOn'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          includeBlanksInLessThan: true,
          includeBlanksInGreaterThan: true,
          includeBlanksInEquals: true,
          filterOptions: ['equals', 'notEqual', 'lessThan', 'greaterThan', 'empty'],
          comparator: dateWithoutTimeComparator
        }
      },
      {
        colId: 'error',
        field: 'Error',
        width: 250,
        resizable: true,
        pinned: false,
        suppressAutoSize: false,
        suppressSizeToFit: true,
        suppressMovable: true,
        headerName: this.translationService.instant('MM.syncFaults.dialog.colError'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          filterOptions: ['contains', 'notContains', 'equals', 'notEqual']
        },
        comparator: customComparator,
      },
      {
        colId: 'fUid',
        field: 'fUid',
        width: 100,
        hide: true, // !showIdColumns,
        resizable: true,
        pinned: false,
        suppressAutoSize: true,
        suppressSizeToFit: true,
        suppressMovable: true,
        headerName: this.translationService.instant('MM.project-config.user-defineds.id'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true,
          filterOptions: ['contains', 'notContains', 'equals', 'notEqual']
        }
      }
    ];
  }

  ngOnDestroy(): void {
  }

  private async setDataSource() {
    this.loadingSubject.next(true);

    const project = await firstValueFrom(this.projectService.currentProject);

    const currentSyncState = await firstValueFrom(this.faultsSyncStateService.currentSyncState$);
    const faultIds = Object.values(currentSyncState.syncState).map(x => x.fault?.uid).filter(f => f);
    let loadedFaults: FaultData[] = [];
    if(!this.connectivityService.isOfflineVal){
      loadedFaults = await this.faultService.loadEditFaults(project.MyDocmaUid, project.Structure.Id, faultIds.map(m => ({uid: m} as Fault) ));
    }

    const groupedPatches = this.patchService.groupByFuid(currentSyncState.errorPatches);

    const syncStates = Object.values(currentSyncState.syncState).map(m => {
      const f = (m.fault?.id ? loadedFaults?.find(x => x.Id === m.fault?.id) : m.fault.data);
      let newFaultDesc1_1: string;
      let newFaultNumber2: string;

      if (!m.fault?.id && groupedPatches.hasOwnProperty(m.fault.uid)) {
        const changeState = this.patchService.generateChangeStateFromPatches(groupedPatches[m.fault.uid]);
        newFaultDesc1_1 = changeState.data.Desc1_1;
        newFaultNumber2 = changeState.data.Number2;
      }

      const state = {
        SyncStatus: (m.error ? SyncStatusEnum.Error : SyncStatusEnum.NotSync),
        Number1: (m.fault?.data?.Number1 ? m.fault?.data?.Number1 : f?.Number1),
        Number2: (newFaultNumber2 ? newFaultNumber2 : (m.fault?.data?.Number2 ? m.fault?.data?.Number2 : f?.Number2)),
        Desc1_1: (newFaultDesc1_1 ? newFaultDesc1_1 : (m.fault?.data?.Desc1_1 ? m.fault?.data?.Desc1_1 : f?.Desc1_1)),
        ModifiedOn: m.fault?.changeState.date,
        LastSyncAttemptOn: m.fault?.syncState.date,
        Error: m.error
      } as FaultSyncState;

      return state;
    });

    if (!syncStates) {
      this.loadingSubject.next(false);
      return;
    }

    this.currentSyncStates = syncStates;
    this.hasErrorsSubject.next(currentSyncState.countWithSyncError > 0);

    if (this.gridApi) {
      this.gridApi.setRowData(syncStates);
      this.gridApi.clearFocusedCell();

      if (this.delaySizeColumnsToFit) {
        setTimeout(() => this.columnApi.autoSizeAllColumns(), 175);
      } else {
        this.columnApi.autoSizeAllColumns();
      }
      this.delaySizeColumnsToFit = false;
    }

    this.loadingSubject.next(false);
  }

  public uploadTicketFile(zip: Blob): Observable<string> {

    const formData: FormData = new FormData();
    formData.append('file', zip, this.getFileName('_files', 'zip'));

    return this.httpClient.post<any>(`${this.taskConfig.apiUrl.replace(/\/+$/, '')}/files`, formData)
      .pipe(map(uploaded => {
        return uploaded.id;
      }),
      catchError(e  => {
        console.warn(`Error uploading backup file to support-api.`);
        return of(null);
      }));
  }

  public createTicket(ticket: FormData): Observable<Ticket> {

    return this.httpClient.post<Ticket>(`${this.taskConfig.apiUrl.replace(/\/+$/, '')}/tickets`, ticket)
        .pipe(
            map(taskResult => {
              return taskResult;
            })
        );
  }

  private createTicketFormData(commonGroup: CommonGroupValue, commonQuestion: QuestionGroupValue, files: IdedMydocmaFile[] | File[] | Blob[]): FormData {
    const ticketFormData = new FormData();
    const deviceInfo = this.deviceService.getDeviceInfo();
    if (this.deviceService.isDesktop()) {
      ticketFormData.append('custom_fields[cf_gert]', 'PC / Laptop');
      ticketFormData.append('custom_fields[cf_art]', 'Browser');
    } else {
      ticketFormData.append('custom_fields[cf_gert]', 'Mobil');
      ticketFormData.append('custom_fields[cf_art]', 'PWA');
    }
    const possibleBrowsers = ['Edge', 'Firefox', 'Safari', 'Chrome'];
    if (!deviceInfo.browser) {
      ticketFormData.append('custom_fields[cf_browser405925]', 'Nicht bekannt');
    } else if (possibleBrowsers.includes(deviceInfo.browser)) {
      ticketFormData.append('custom_fields[cf_browser405925]', deviceInfo.browser);
    } else {
      ticketFormData.append('custom_fields[cf_browser405925]', 'Sonstige');
    }
    ticketFormData.append('email', commonGroup.email);
    ticketFormData.append('subject', commonQuestion.subject);
    if (commonQuestion.clientInfo) {
      ticketFormData.append('description', commonQuestion.description + ' --- Clientinfo: ' + commonQuestion.clientInfo);
    } else {
      ticketFormData.append('description', commonQuestion.description);
    }
    ticketFormData.append('type', TypeEnum[commonQuestion.type]);
    ticketFormData.append('status', '3');
    ticketFormData.append('priority', PriorityEnum[commonQuestion.type]);
    if (commonGroup.project) {
      ticketFormData.append('custom_fields[bauvorhaben]', commonGroup.project);
    }
    if (this.taskConfig?.defaultTicket.custom_fields?.module) {
      ticketFormData.append('custom_fields[' + FreshdeskCustomfieldsEnum[this.taskConfig.defaultTicket.custom_fields.module] + ']', 'true');
    }
    if (this.taskConfig?.defaultTicket?.custom_fields?.nutzungsart) {
      ticketFormData.append('custom_fields[cf_nutzungsart]', this.taskConfig?.defaultTicket?.custom_fields?.nutzungsart);
    }
    if (commonGroup.phone) {
      ticketFormData.append('custom_fields[rckrufnummer]', commonGroup.phone);
    }

    ticketFormData.append('custom_fields[cf_clientinfo]', window.navigator.userAgent);

    for (const file of files) {
      ticketFormData.append('attachments[]', file);
    }

    return ticketFormData;
  }

  private async convertToFile(blob: Blob, fileName: string): Promise<File> {
     const file = new File([blob], fileName);
    // const file = blob as MydocmaFile;
    // file.name = fileName;
     return file;
  }

  private getFileName(suffix: string, extension: string): string {
    const date = new Date();
    return `${date.getFullYear()}${(date.getMonth() + 1 + '').padStart(2, '0')}${(date.getDate() + '').padStart(2, '0')}_${(date.getHours() + '').padStart(2, '0')}${(date.getMinutes() + '').padStart(2, '0')}${suffix}.${extension}`;
  }

  async onCancel() {
    this.dialogRef.close();
  }
  retrySync() {
    this.faultSyncService.startSync();
    this.dialogRef.close(undefined);
  }

  async cleanupAndRetrySync() {
    this.loadingSubject.next(true);

    const userPermission = await firstValueFrom(this.projectLoaderService.projectUserPermissions.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded)).pipe(map(x => x.data)));
    const customer = await firstValueFrom(this.customerService.getCurrentCustomer());
    const currentSyncState = await firstValueFrom(this.faultsSyncStateService.currentSyncState$);

    const project = await firstValueFrom(this.projectService.currentProject);
    const user = await firstValueFrom(this.authService.user);
    const projectUserPermissions = await firstValueFrom(this.projectLoaderService.projectUserPermissions);
    const companies = await firstValueFrom(this.projectLoaderService.companies);
    const userCompany = companies?.data?.find(x => x.Id === projectUserPermissions?.data?.User?.Company?.Id);

    const file = await this.convertToFile(new Blob([JSON.stringify(currentSyncState.errorPatches, null, '\t')], { type: 'application/json' }), this.getFileName('_patches', 'json'));

    const groupedErrorPatches = this.patchService.groupByFuid(currentSyncState.errorPatches);
    const faultUids = Object.keys(groupedErrorPatches);
    const errorFiles: {[uid: string]: File} = {};

    const backupZip = new JSZip();
    backupZip.file<'uint8array'>(file.name, new Uint8Array(await file.arrayBuffer()));

    await Promise.all(Object.keys(currentSyncState.errorPatches).map(async key => {
      const patch: FaultPatch = currentSyncState.errorPatches[key];
      if (patch.operation.path === FaultOperationPathEnum.attachment) {
        const f = await this.syncFileService.getFile(project.MyDocmaUid, patch.oUid);
        if (f) {
          backupZip.file<'uint8array'>(f.name, new Uint8Array(f.buffer));

          const fi = await this.convertToFile(new Blob([f.buffer], {type: f.mimeType}), f.name);
          errorFiles[f.uid] = fi;
        }
      }
    }));

    const backupFiles = [file, ...Object.values(errorFiles)];
    let backupFileId: string;

    try {
      await backupZip.generateAsync({ type: 'blob' })
          .then(async zip => {
            backupFileId = await firstValueFrom(this.uploadTicketFile(zip));
            console.warn(backupFileId);
            // FileSaver.saveAs(zip, `download.zip`);
          });
    }
    catch (err){
      this.logger.error(err, '', 'MmFaultsSyncDialogComponent');
    }

    let singleFaultNumber = '';
    if (faultUids.length === 1) {
      const errorFault = await this.persistenceService.get(project.MyDocmaUid, faultUids[0]);
      if (errorFault?.data?.Number1) {
        singleFaultNumber = `Nummer: '${errorFault.data.Number1}'<br>`;
      }
    }

    const commonGroup = {
      username: 'EDR Software Entwicklung',
      email: 'development@edr-software.com',
      module: 'MM',
      phone: '',
      contact: 'mail',
      project: project.Name1 + ' - ' + project.Name2,
    } as CommonGroupValue;

    const questionGroup = {
      clientInfo: null,
      type: 'problem',
      subject: `Cleanup Sync-Queue // ${user.email}`,
      description:
`User: '${user.name}'<br>
User E-Mail: '${user.email}'<br>
User Firma: '${(userCompany?.Name1 ?? '-')}'<br>
User Id: ${userPermission.User.Id}<br>
${singleFaultNumber}
AppVersion: ${package_json.version}<br>
Customer: '${customer.name}'<br>
Schema: '${this.jwtAuthService.getAccessTokenClaims().db_schema}'<br>
Project: '${project.Name1 + ' - ' + project.Name2}'<br>
Project Id: ${project.Id}<br>

Backup file-id: '${backupFileId}'<br>
sync-states: <pre>${JSON.stringify(this.currentSyncStates, null, 4)}</pre>`,
    } as QuestionGroupValue;

    const ticketFormData = this.createTicketFormData(commonGroup, questionGroup, [file]);

    this.createTicket(ticketFormData)
      .subscribe(async (postResponse) => {
        if (postResponse) {

          await this.patchService.remove(project.MyDocmaUid, currentSyncState.errorPatches.map(p => p.operation.id));

          const groupedPatches = this.patchService.groupByFuid(currentSyncState.errorPatches);

          // const faultUids = Object.keys(groupedPatches);
          // currentSyncState.errorPatches.map(m => m.fUid);
          const allPatches = await this.patchService.getAll(project.MyDocmaUid);
          const errorFaults = await this.persistenceService.getAll(project.MyDocmaUid, faultUids);
          const syncStateChanges: SyncStateChange[] = [];

          await Promise.all(faultUids.map(async fUid => {
            const patches = groupedPatches[fUid];
            syncStateChanges.push({faultUid: fUid, mydocmaUid: project.MyDocmaUid, syncState: new SyncState({ status: SyncStatusEnum.NotSync })} as SyncStateChange);
          }));

          await this.faultService.validateChangeState(project.MyDocmaUid, allPatches, errorFaults);
          await this.persistenceService.clearAllSyncStates(project.MyDocmaUid, faultUids);

          await Promise.all(Object.keys(errorFiles).map(async fileUid => {
            await this.persistenceService.removeFile(project.MyDocmaUid, fileUid);
          }));

          await Promise.all(errorFaults.filter(x => x.id === undefined).map(async f => {
            /* TODO MMW-5194 */
            await this.persistenceService.removeAll(project.MyDocmaUid, [f.uid], null, null);
            await this.faultsLoaderService.removeFaults([f]);
          }));


          await this.faultsSyncStateService.set(project.MyDocmaUid);
          this.faultSyncService.syncFaultsStateSubject.next({changes: syncStateChanges, startingFaultUids: null, notifyError: false});

          // TODO: UPDATE CHANGE_STATE FOR GRID-FAULTS OBJECTS SO NO RELOAD AG-GRID WILL BE NEEDED IN FUTURE

          this.dialogRef.close({isSuccessful: true, ticketId: postResponse.id});
        }
      }, ((error) => {
        this.dialogRef.close({isSuccessful: false});
      }));

  }

  async openInfoPopup() {
    this.matDialog.open(MmFaultsSyncStatusInfoPopupComponent, { panelClass: 'sync-status-info-popup' });
  }
}

export const dateWithoutTimeComparator = (a: Date, b: Date) => {
  if (b == null) {
    return 0;
  }

  const aWithoutTime = new Date(a).setHours(0, 0, 0, 0);
  const bWithoutTime = new Date(b).setHours(0, 0, 0, 0);

  if (aWithoutTime === bWithoutTime) {
    return 0;
  } else {
    return aWithoutTime > bWithoutTime ? -1 : 1;
  }
};
